import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconCheck = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <path
      d='M20 6 9 17l-5-5'
      fill='none'
      stroke='currentColor'
      strokeWidth='2.4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </SDIcon>
)

export default IconCheck
